export default "__VITE_ASSET__Ca4_2mIh__"